import { reactive } from "vue";

const themeState = reactive({
  isDark: false, // 初始状态
});

export const useTheme = () => {
  const toggleTheme = () => {
    themeState.isDark = !themeState.isDark;
    const newTheme = themeState.isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  const initializeTheme = () => {
    const savedTheme =
      document.documentElement.getAttribute("data-theme") || "light"; // 默认主题
    themeState.isDark = savedTheme === "dark";
    document.documentElement.setAttribute("data-theme", savedTheme);
  };

  return {
    themeState, // 导出状态
    toggleTheme,
    initializeTheme,
  };
};
